// /agent/download — where the site's "Download for Mac" lands. It counts one download against the
// channel that brought the visitor (the ?src= the site carried into this link, kept by
// captureAttribution for the sign-in that follows in the Mac app), then starts the file. Counting
// never blocks the download: it waits at most a moment, and a failed count still downloads.
import { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { AGENT_API_BASE } from "../utils/api";
import { captureAttribution } from "../utils/attribution";
import { AGENT_DMG } from "../utils/landing";

const link = { color: "#2da894", fontWeight: 600, textDecoration: "none" };
const COUNT_WAIT_MS = 1200;

export function countDownload(rec, base = AGENT_API_BASE) {
  const body = JSON.stringify({ src: rec?.src || "", ref: rec?.ref || "" });
  const count = fetch(`${base}/public/download`, {
    method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true,
  }).catch(() => {});
  return Promise.race([count, new Promise((r) => setTimeout(r, COUNT_WAIT_MS))]);
}

export default function AgentDownload({ start = (href) => window.location.assign(href) }) {
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const rec = captureAttribution();
    countDownload(rec).then(() => start(AGENT_DMG));
  }, [start]);

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0b0b0f", color: "#fff", display: "flex", justifyContent: "center", px: 2, py: { xs: 6, md: 10 } }}>
      <Box sx={{ width: "100%", maxWidth: 560 }}>
        <Typography variant="h4" fontWeight={700} gutterBottom>Downloading Assertion for Mac</Typography>
        <Typography sx={{ opacity: 0.8, mb: 3 }}>
          Your download should start in a moment. If it doesn&rsquo;t,{" "}
          <Box component="a" href={AGENT_DMG} sx={link}>download it here</Box>.
        </Typography>
        <Box component="ol" sx={{ pl: 2.5, m: 0, display: "grid", gap: 1.25, opacity: 0.9 }}>
          <li>Open the file and drag Assertion into Applications.</li>
          <li>Open Assertion and sign in. Your free plan starts right away.</li>
        </Box>
        <Typography sx={{ mt: 4, opacity: 0.7, fontSize: 14 }}>
          Not on a Mac with Apple Silicon? The plugin brings the same memory to Claude Code, Cursor or Codex:{" "}
          <Box component="a" href="/connect" sx={link}>get the plugin</Box>.
        </Typography>
      </Box>
    </Box>
  );
}
